import { createClient } from '@supabase/supabase-js';

const env = (import.meta as any)?.env ?? {};
const SUPABASE_URL = env.VITE_SUPABASE_URL || process.env.VUE_APP_SUPABASE_URL;
const SUPABASE_ANON_KEY = env.VITE_SUPABASE_ANON_KEY || process.env.VUE_APP_SUPABASE_ANON_KEY;

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error(
    '[supabase] Missing env vars: SUPABASE_URL / SUPABASE_ANON_KEY'
  );
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true, // Keep session in storage
    autoRefreshToken: true, // Access token auto refresh
    detectSessionInUrl: true,
  },
});